import React from 'react';
import './styles.css';

export default [
  {
    title: 'Inspection Date',
    dataIndex: 'inspectionDate',
    key: 'inspectionDate',
    sorter: true
  },

  {
    title: 'Days open',
    dataIndex: 'daysOpen',
    key: 'daysOpen'
  },
  {
    title: 'Asset Identification Number',
    dataIndex: 'salesforceAssetId',
    key: 'salesforceAssetId',
    sorter: true
  },
  {
    title: 'Asset Barcode Number',
    dataIndex: 'assetBarcode',
    key: 'assetBarcode',
    sorter: true
  },
  {
    title: 'Asset Name',
    dataIndex: 'assetName',
    key: 'assetName',
    sorter: true
  },
  {
    title: 'Driver Name',
    dataIndex: 'driverName',
    key: 'driverName',
    sorter: true
  },
  {
    title: 'Asset Condition',
    dataIndex: 'assetCondition',
    key: 'assetCondition',
    sorter: true,
    render: (_, { assetCondition }) => (
      <div>{assetCondition === 'satisfactory' ? 'Satisfactory' : 'Not Satisfactory'}</div>
    )
  },

  {
    title: 'Location',
    dataIndex: 'branchName',
    key: 'branchName',
    sorter: true
  }
];
